import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const brandApi = axios.create({ baseURL: API });

brandApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("bv_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

brandApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && window.location.pathname.startsWith("/brand-portal")) {
      localStorage.removeItem("bv_token");
      localStorage.removeItem("bv_brand");
      window.location.href = "/brand-login";
    }
    return Promise.reject(err);
  }
);

export function setBrandAuth(token, brand) {
  localStorage.setItem("bv_token", token);
  localStorage.setItem("bv_brand", JSON.stringify(brand));
}

export function getBrandAuth() {
  try {
    const t = localStorage.getItem("bv_token");
    const b = localStorage.getItem("bv_brand");
    return t ? { token: t, brand: b ? JSON.parse(b) : null } : null;
  } catch {
    return null;
  }
}

export function brandLogout() {
  localStorage.removeItem("bv_token");
  localStorage.removeItem("bv_brand");
  window.location.href = "/brand-login";
}
